import axios from "axios";

const URL = "/api/v1/information_guides";

const informationGuidesApi = {
  fetch: resource => axios.get(`${URL}/${resource}`),
};

export default informationGuidesApi;
